module.exports = __webpack_public_path__ + "img/syukyaku-EC-mo-002.08c8b71b.jpg";